import { combineReducers } from 'redux'

import resultados from './detalhesOrdensPagamentosExtraorcamentarias'

export default combineReducers({ resultados })
